import * as ImagePath from "./Image.path";
import {LicenseDto} from "../../dto/License.dto";

export default function LicenseInfo(props: any) {
    const getLicenseIcon = (name: string) => {
        switch (name) {
            case "DFOS Control System":
                return ImagePath.control;
            case "DFOS PMS":
                return ImagePath.panorama;
            default:
                return ImagePath.ims;
        }
    }

    return (
        <div className="member-detail-license">
            <div className="license-title">
                활성화된 라이선스
            </div>
            {
                props.licenses && props.licenses.length > 0 ? (
                    <div className="member-license-box">
                        <div className="license-box-title">
                            <div className="program">
                                프로그램
                            </div>
                        </div>
                        {
                            props.licenses.map((license: LicenseDto) => {
                                return (
                                    <div key={license.seq} className="license-box-contents">
                                        <div className="program">
                                            <img src={getLicenseIcon(license.name)} alt="icon"/>
                                            <div className="text">
                                                {license.name}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                ) : (
                    <div className="empty-box">
                        활성화된 라이선스 없음
                    </div>
                )
            }
        </div>
    );
}